import React, {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Col, Row, Card, Form} from "react-bootstrap";
import Logo from "../assets/images/logo.svg"
import {useNavigate} from "react-router-dom";
import {createVerification, getUserMfaDetails, resetVerification} from "../actions/LoginActions";
import Loader from "../components/Loader";
import AlertModal from "../components/AlertModal";
import LoginImage from "../components/LoginImage";
import useAuthRedirect from "../hooks/auth/useAuthRedirect";

function VerificationCodeSend() {
    const history = useNavigate()
    const dispatch = useDispatch()
    const [verificationType, setVerificationType] = useState({
        display: false,
        type: "",
    });
    const [disableSubmit, setDisableSubmit] = useState(true);
    const [alertModal, setAlertModal] = useState({
        display: false,
        type: "",
        message: ""
    })

    const createVerificationDetails = useSelector(state => state.createVerification)
    const {loading} = createVerificationDetails

    const getUserMfaData = useSelector(state => state.getUserMfaDetails)
    const {loadingMfa, mfaInfo} = getUserMfaData

    useAuthRedirect();

    useEffect(() => {
        dispatch(getUserMfaDetails());
    }, []);

    const selectVerification = (type) => {
        setDisableSubmit(false);
        setVerificationType({
            display: true,
            type: type,
        })
    };

    const submitHandler = (event) => {
        event.preventDefault();

        dispatch(createVerification(verificationType.type));
    };

    useEffect(() => {
        if (createVerificationDetails.verificationInfo) {
            dispatch(resetVerification());
            history('/verification-code-add', {state: {type: verificationType.type}});
        }

        if (createVerificationDetails.error) {
            setAlertModal({
                display: true,
                type: "error",
                message: "Failed to request verification code"
            })
        }
    }, [createVerificationDetails]);

    const closeAlert = () => {
        setAlertModal({
            display: false
        })
        dispatch(resetVerification())
    }

    return (
        <Row className="login-background">
            {alertModal.display &&
                <AlertModal heading={alertModal.message} type={alertModal.type} result={closeAlert}/>}
            {loading && <Loader/>}
            {loadingMfa && <Loader/>}
            <Col lg={{span: 4, offset: 1}} md={{span: 4, offset: 1}}>
                <Card className="card-body">
                    <img src={Logo} alt="logo" className="logo"/>
                    {mfaInfo && <form className="margin-top">
                        <p className="header">Verification code</p>
                        <p className="sub-header">Please choose any one option to get verification code</p>
                        <div>
                            {mfaInfo.map((item, i) =>
                                 (
                                    <Form.Check
                                        name="contacts"
                                        label={`Send Email to: ${item.optionText}`}
                                        type="radio"
                                        key={i}
                                        id={item.optionValue}
                                        onClick={() => selectVerification(item.optionValue)}
                                    />
                                )
                            )}
                        </div>
                        <div className="login-button">
                            <button
                                onClick={submitHandler}
                                disabled={disableSubmit}
                                type="submit"
                                className={`button-solid ${disableSubmit ? "button-inactive" : "button-active"} `}
                            >
                                Send Code
                            </button>
                        </div>
                    </form>}
                    <div className="copyright">
                        <p className="sub-footer">v2.0</p>
                        <p className="sub-footer">copyright text</p>
                    </div>
                </Card>
            </Col>
            <Col lg={{span: 7, offset: 0}} md={{span: 7, offset: 0}}>
                <LoginImage/>
            </Col>
        </Row>
    );
}

export default VerificationCodeSend;